import { useEffect } from 'react';
import { useNavigate } from '@tanstack/react-router';

/**
 * Teleport login gate. Normally it just enters the dashboard. With
 * ?reason=api_unauthorized (set by the API client when a fresh Teleport
 * session was still refused) it stays put, so the user is not bounced in a loop.
 */
export default function Login() {
  const navigate = useNavigate();
  const refused = new URLSearchParams(window.location.search).get('reason') === 'api_unauthorized';
  const launchUrl = `https://access.otrtech.co.uk/web/launch/${window.location.host}?path=%2F`;

  useEffect(() => {
    if (!refused) navigate({ to: '/' });
  }, [navigate, refused]);

  return (
    <div className="h-full flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-slate-900/80 border border-slate-800 rounded-xl p-6 space-y-4 backdrop-blur-md shadow-2xl text-center">
        <div className="text-center space-y-1">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-500/10 border border-emerald-500/30 text-emerald-400 text-xs font-semibold uppercase tracking-wider mb-2">
            🔒 Teleport Zero-Trust Enforced
          </div>
          <h1 className="text-xl font-bold text-white">
            {refused ? 'The API did not accept your session' : 'Opening Dashboard...'}
          </h1>
          <p className="text-xs text-slate-400">
            {refused
              ? 'You are signed in to Teleport, but the OTR API refused the request. Try signing in again; if it keeps happening, ask an admin to check the API logs for Teleport token errors.'
              : 'Continuing with your Teleport session.'}
          </p>
        </div>

        <div className="pt-2">
          <a
            href={launchUrl}
            className="w-full inline-flex items-center justify-center gap-2 bg-emerald-500 hover:bg-emerald-400 text-slate-950 font-semibold rounded-md py-2.5 text-xs transition shadow-lg shadow-emerald-500/20"
          >
            {refused ? 'Sign in again' : 'Open Teleport Access Gateway'}
          </a>
        </div>
      </div>
    </div>
  );
}
